import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import EmailIcon from "@mui/icons-material/Email";
import "./stylesheets/floating.css";

const FloatingSocials = () => {
	return (
		<div id="floatingSocials">
			<a href="https://github.com/jksingh1504" target="blank">
				<div>
					<GitHubIcon />
				</div>
			</a>
			<a href="https://www.linkedin.com/in/jyoti-kamal-singh" target="blank">
				<div>
					<LinkedInIcon />
				</div>
			</a>
			<a href="mailto:Jyotikamal.official@gmail.com">
				<div>
					<EmailIcon />
				</div>
			</a>
		</div>
	);
};

export default FloatingSocials;
